import { Injectable } from '@angular/core';

export const DEFAULT_FIXED_DASHBOARD_INDICATORS = [
  'implicit-ipca',
  'cdi',
  'ipca',
  'currency:USD',
  'currency:EUR',
  'currency:CNY',
  'sofr',
  'key:selic-target',
];

const STORAGE_KEY = 'vault.dashboard-management.fixed-indicators.v3';
const KEY_INDICATORS_ORDER_STORAGE_KEY = 'vault.dashboard-management.key-indicators-order.v1';
const MIN_INDICATORS = 4;
const MAX_INDICATORS = 8;

@Injectable({
  providedIn: 'root',
})
export class DashboardIndicatorPreferencesRepository {
  loadFixedIndicatorIds(): string[] {
    if (typeof localStorage === 'undefined') {
      return [...DEFAULT_FIXED_DASHBOARD_INDICATORS];
    }

    try {
      const rawValue = localStorage.getItem(STORAGE_KEY);
      if (!rawValue) {
        return [...DEFAULT_FIXED_DASHBOARD_INDICATORS];
      }

      const parsedValue = JSON.parse(rawValue);
      if (!Array.isArray(parsedValue)) {
        return [...DEFAULT_FIXED_DASHBOARD_INDICATORS];
      }

      return this.normalizeSelection(parsedValue.filter(item => typeof item === 'string'));
    } catch {
      return [...DEFAULT_FIXED_DASHBOARD_INDICATORS];
    }
  }

  saveFixedIndicatorIds(indicatorIds: string[]): void {
    const normalizedSelection = this.normalizeSelection(indicatorIds);

    if (typeof localStorage === 'undefined') {
      return;
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(normalizedSelection));
  }

  loadKeyIndicatorOrder(): string[] {
    if (typeof localStorage === 'undefined') {
      return [];
    }

    try {
      const rawValue = localStorage.getItem(KEY_INDICATORS_ORDER_STORAGE_KEY);
      if (!rawValue) {
        return [];
      }

      const parsedValue = JSON.parse(rawValue);
      if (!Array.isArray(parsedValue)) {
        return [];
      }

      return Array.from(new Set(parsedValue.filter(item => typeof item === 'string')));
    } catch {
      return [];
    }
  }

  saveKeyIndicatorOrder(indicatorCodes: string[]): void {
    if (typeof localStorage === 'undefined') {
      return;
    }

    localStorage.setItem(
      KEY_INDICATORS_ORDER_STORAGE_KEY,
      JSON.stringify(Array.from(new Set(indicatorCodes)))
    );
  }

  resetKeyIndicatorOrder(): void {
    if (typeof localStorage === 'undefined') {
      return;
    }

    localStorage.removeItem(KEY_INDICATORS_ORDER_STORAGE_KEY);
  }

  private normalizeSelection(indicatorIds: string[]): string[] {
    const uniqueIds = Array.from(new Set(indicatorIds));

    if (uniqueIds.length < MIN_INDICATORS || uniqueIds.length > MAX_INDICATORS) {
      return [...DEFAULT_FIXED_DASHBOARD_INDICATORS];
    }

    return uniqueIds;
  }
}
